import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'VulnerabilitySeverity',
  props: {
    severity: null,
    postfix: null
  },
  setup(__props: any) {



const severityColors: Record<string, { outer: string; inner: string }> = {
  high: { outer: 'tw:bg-vuln-high-light', inner: 'tw:bg-vuln-high' },
  medium: { outer: 'tw:bg-vuln-medium-light', inner: 'tw:bg-vuln-medium' },
  low: { outer: 'tw:bg-vuln-low/20', inner: 'tw:bg-vuln-low' },
  primary: { outer: 'tw:bg-[#FDC7C0]', inner: 'tw:bg-[#FB7462]' },
  secondary: { outer: 'tw:bg-[#FFE1C6]', inner: 'tw:bg-[#FF7A08]' },
  supporting: { outer: 'tw:bg-[#DFEBFF]', inner: 'tw:bg-[#3180F6]' },
};

function getSeverityColors(severity: string) {
  return severityColors[severity] ?? severityColors.high;
}

return { __sfc: true,severityColors, getSeverityColors }
}

})